import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stockdisponible',
  templateUrl: './stockdisponible.component.html',
  styleUrls: ['./stockdisponible.component.css']
})
export class StockdisponibleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
